import { z } from 'zod';
export const partnershipSettingsSchemaInput = z.object({
    partnershipsEnabled: z.boolean(),
    partnershipsRequiredMemberCount: z.number().min(0).default(0),
});
